var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.419,
    viewBox: "0 0 15.5 15.419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light_Calendar",
    "data-name": "Iconly/Light/Calendar",
    transform: "translate(0.65 0.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_200",
    d: "M0,.473H14.061",
    transform: "translate(0.073 4.754)",
    fill: "none",
    stroke: "#4165f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_201",
    d: "M.459.473H.466",
    transform: "translate(10.146 7.511)",
    fill: "none",
    stroke: "#4165f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_202",
    d: "M.459.473H.466",
    transform: "translate(6.645 7.511)",
    fill: "none",
    stroke: "#4165f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_203",
    d: "M.459.473H.466",
    transform: "translate(3.137 7.511)",
    fill: "none",
    stroke: "#4165f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_204",
    d: "M.459.473H.466",
    transform: "translate(10.146 10.255)",
    fill: "none",
    stroke: "#4165f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_205",
    d: "M.459.473H.466",
    transform: "translate(6.645 10.255)",
    fill: "none",
    stroke: "#4165f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_206",
    d: "M.459.473H.466",
    transform: "translate(3.137 10.255)",
    fill: "none",
    stroke: "#4165f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_207",
    d: "M.463,0V2.323",
    transform: "translate(9.827)",
    fill: "none",
    stroke: "#4165f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_208",
    d: "M.463,0V2.323",
    transform: "translate(3.454)",
    fill: "none",
    stroke: "#4165f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.444,0H3.764C1.447,0,0,1.155,0,3.278V9.666C0,11.822,1.447,13,3.764,13h6.673C12.761,13,14.2,11.842,14.2,9.72V3.278C14.208,1.155,12.768,0,10.444,0Z",
    transform: "translate(0 1.115)",
    fill: "none",
    stroke: "#4165f6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.836520eb9a3cd06aa3e8080867e5ad1e.svg";
export { ForwardRef as ReactComponent };